const compressImage = async (file, { 
    maxWidth = 800,
    maxHeight = 800,
    quality = 0.8,
    maxSizeMB = 1
} = {}) => {
    return new Promise((resolve, reject) => {
        // Créer un FileReader pour lire le fichier
        const reader = new FileReader();
        reader.readAsDataURL(file);
        
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            
            img.onload = () => {
                // Créer un canvas pour le redimensionnement
                const canvas = document.createElement('canvas');
                let width = img.width;
                let height = img.height;
                
                // Calculer les nouvelles dimensions
                if (width > height) {
                    if (width > maxWidth) {
                        height = Math.round((height * maxWidth) / width);
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width = Math.round((width * maxHeight) / height);
                        height = maxHeight;
                    }
                }
                
                // Définir les dimensions du canvas
                canvas.width = width;
                canvas.height = height;
                
                // Dessiner l'image redimensionnée
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);
                
                // Convertir en Blob avec compression
                canvas.toBlob((blob) => {
                    if (!blob) {
                        reject(new Error('La compression a échoué'));
                        return;
                    }
                    
                    // Si le blob est toujours trop grand, augmenter la compression
                    if (blob.size > maxSizeMB * 1024 * 1024) {
                        const newQuality = quality * (maxSizeMB * 1024 * 1024 / blob.size);
                        canvas.toBlob(
                            (newBlob) => {
                                if (!newBlob) {
                                    reject(new Error('La compression additionnelle a échoué'));
                                    return;
                                }
                                resolve(newBlob);
                            },
                            'image/jpeg',
                            Math.min(newQuality, quality)
                        );
                    } else {
                        resolve(blob);
                    }
                }, 'image/jpeg', quality);
            };
            
            img.onerror = () => {
                reject(new Error('Erreur lors du chargement de l\'image'));
            };
        };
        
        reader.onerror = () => {
            reject(new Error('Erreur lors de la lecture du fichier'));
        };
    });
};

export const imageCompressor = {
    // Pour les photos de profil
    compressProfilePicture: async (file) => {
        return compressImage(file, {
            maxWidth: 400,
            maxHeight: 400,
            quality: 0.7,
            maxSizeMB: 0.5
        });
    },
    
    // Pour les images générales
    compressGeneralImage: async (file) => {
        return compressImage(file, {
            maxWidth: 1200,
            maxHeight: 1200,
            quality: 0.8,
            maxSizeMB: 2
        });
    }
};